/*----------------------------------
- DEPENDANCES
----------------------------------*/

// Npm
import React from 'react';
import type { ComponentChild } from 'preact';

// Local
import { history } from '@/client/services/router/request/history';

export const shouldOpenNewTab = (url: string, target?: string) =>
    url && (target !== undefined || !['/', '#'].includes(url[0]) || url.startsWith('//'));

/*----------------------------------
- COMPONENT
----------------------------------*/
export const Link = ({
    to,
    ...props
}: {
    to: string;
    children?: ComponentChild;
    class?: string;
    className?: string;
} & React.HTMLProps<HTMLAnchorElement>) => {
    const openNewTab = shouldOpenNewTab(to, props.target);
    const originalOnClick = props.onClick;

    if (openNewTab) props.target = '_blank';
    else
        props.onClick = (e) => {
            originalOnClick?.(e);
            if (e.defaultPrevented) return false;
            history?.push(to);
            e.preventDefault();
            return false;
        };

    return <a {...props} href={to} />;
};
